import { render, staticRenderFns } from "./RentType.vue?vue&type=template&id=76b6774c&scoped=true&"
import script from "./RentType.vue?vue&type=script&lang=js&"
export * from "./RentType.vue?vue&type=script&lang=js&"
import style0 from "./RentType.vue?vue&type=style&index=0&id=76b6774c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b6774c",
  null
  
)

export default component.exports